<template>	
		<div class="survey-post survey-post-completed">
				
				<div class="survey-post-top">
					<div class="deleteSurvey">
						<button class="del-btn" v-if="isAdmin"  @click="openDeleteModal(surveyData.survey.quoteReference)"></button>
					</div>
					<deleteSurveyConfirmModal :quoteReference="surveyData.survey.quoteReference" quoteStatus="Open Quotations"/>
					<div class="survey-post-top-attributes col md-7">	
						<div class="quoteNumber">
							<span class="survey-post-title">Quote Number</span>
							<span class="survey-post-entry">{{surveyData.survey.quoteReference}}</span>
						</div>
                        <div class="client" v-if="isAdmin">
                            <span class="survey-post-title">Client</span>
							<span class="survey-post-entry">{{surveyData.user.alias}}</span>
                        </div>
                        <div class="companyName" v-if="isAdmin">
                            <span class="survey-post-title">Company Name</span>
							<span class="survey-post-entry">{{surveyData.user.companyName}}</span>
                        </div>
						<div class="areas">
							<span class="survey-post-title">Areas</span>
							<span class="survey-post-entry">{{surveyData.areas.length}}</span>
						</div>
						<div class="totalarea">
							<span class="survey-post-title">Total Area</span>
							<span class="survey-post-entry">{{surveyData.survey.totalArea | currency('', 0)}}sqm</span>
						</div>
						<div class="totalarea">
							<span class="survey-post-title">Total Cost</span>
							<span class="survey-post-entry">{{surveyData.survey.quotePrice | currency('£')}}</span>
						</div>
                        <div class="startDate" v-if="surveyData.survey.surveyStatus === 2">
							<span class="survey-post-title">Date Started</span>
							<span class="survey-post-entry">{{surveyData.survey.surveyStartDate | niceDate}}</span>
						</div>
                        <div class="finishDate" v-if="surveyData.survey.surveyStatus === 3">
							<span class="survey-post-title">Date Completed</span>
							<span class="survey-post-entry">{{surveyData.survey.completed | niceDate}}</span>
						</div>
                        <div class="status" v-if="surveyData.survey.surveyStatus === 2">
							<span class="survey-post-title">Status</span>
							<span class="survey-post-entry">Ongoing</span>
						</div>
					</div>
					<div class="survey-post-top-controls col md-5">	
                        <div class="share-report" v-if="!isAdmin">
							<button 
								class="btn btn-small" 
								v-clipboard:copy="shareurl"
								v-clipboard:success="handleCopyStatus"
							>
								Share Survey
							</button>
								
							<!-- <a download :href="surveyData.survey.quoteFilesUrl" class="btn btn-small"></a> -->
						</div>
                        <div class="download" v-if="!isAdmin">
							<a download :href="surveyData.survey.surveyPDFUrl">
								<button class="btn btn-small dl">Download</button>
							</a>
						</div>
						<button class="btn btn-small" @click="openClose" v-if="isAdmin">
							{{toggled === surveyData.survey.quoteReference ? 'Close' : 'Open'}}
						</button>
					</div>
					<div class="clearfix"></div>
				</div>

				<div class="survey-post-body" v-if="isAdmin" v-show="toggled == surveyData.survey.quoteReference">

						<div class="client-details" v-if="isAdmin">	
							<div class="client-details__title">Client Contact Info</div>
							<div class="client-details__email">	
								<span class="client-details__desc">Email Address:</span>
								<span>{{surveyData.user.email}}</span>
							</div>
							<div class="client-details__phone" v-if="surveyData.user.phoneNumber">	
								<span class="client-details__desc">Primary Phone number :</span>
								<span>{{surveyData.user.phoneNumber}}</span>
							</div>
							<div class="client-details__phone" v-if="surveyData.user.phoneNumberTwo">	
								<span class="client-details__desc">Secondary Phone number : </span>
								<span>{{surveyData.user.phoneNumberTwo}}</span>
							</div>
                        </div>

                        <div class="survey-post-area" v-for="(area, i) in surveyData.areas" :key="i">
                            <div class="indexer">
                                {{ i + 1}} of {{surveyData.areas.length}}
                            </div>
                            <div class="map-viewer"  v-if="isAdmin">
                                <button class="btn btn-small"  @click="openPreviewArea(area.areaId)">
                                    View
                                </button>
                                <previewStaticMapModal :key="''+i" :areaTitle="area.areaTitle" :areaDesc="area.areaDescription" :areaId="area.areaId" :coordinates="area.kmlCoordinates"/>
                            </div>
							<div class="area-top">	
                                <p class="areaId">Area Id - {{area.areaId}}</p>
							    <div class="survey-post__title">{{area.areaTitle | truncate(70)}}</div>
                            </div>
                            <div class="area-bottom">	
                                <div class="totalArea">	
                                    <span class="area-bot__title">Total Area</span>
                                    <span class="area-bot__val">{{area.areaSquared}}</span>
                                </div>
                               <div class="userUpload">	
                                    <span class="area-bot__title">Grid &amp; Height</span>
                                    <span class="area-bot__val">{{area.userUpload === false ? 'Custom uploaded' : 'Related to OS'}}</span>
                                </div>
                                <div class="additionalDetails">	
                                    <span class="area-bot__title">Additional Details</span>
                                    <span class="area-bot__val" v-if="area.additionalDetails.length === 0">No</span>
                    
                                    <span v-if="area.additionalDetails.length > 0" class="area-bot__val additionals">
                                        Yes - {{area.additionalDetails.join(', ')}}
                                    </span>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="download__completed" v-if="isAdmin && surveyData.survey.surveyStatus === 3">
							<a download :href="surveyData.survey.quoteFilesUrl">
								<button class="btn dl">Download Survey</button>
							</a>
						</div>
                    </div>
					
				</div>

		</div>
</template>

<script>	
import previewStaticMapModal from '../Modals/previewStaticMapModal';
import deleteSurveyConfirmModal from '../Modals/deleteSurveyConfirmModal';
export default {
	props : ['surveyData', 'toggled', 'isAdmin'],
	components : {
		previewStaticMapModal : previewStaticMapModal,
		deleteSurveyConfirmModal : deleteSurveyConfirmModal
	},
	data(){
		return {
			forceDisableSendQuoteBtn : false,
			shareurl : process.env.BASE_URL + '/s/' + this.surveyData.survey.quoteReference,
			uploadData : {
				quotePrice : this.surveyData.survey.quotePrice,
				quotePdf : undefined
            },
            surveyProgressDef : {
                0 : 'Assigning a team',
                20 : 'Planning site visits',
                40 : 'Pre survey checks',
                60 : 'Carrying out the survey',
                80: 'Collating the data for presentation',
                100 : 'Finished!' 
            }
		}
	},
	methods : {
		openClose(){

			this.$emit('openCloseToggle', this.surveyData.survey.quoteReference);
		},
		openPreviewArea(areaId){
			this.$store.commit('openModal', 'previewStaticMapModal' + areaId)
		},
		openDeleteModal(quoteReference){
			this.$store.commit('openModal', 'deleteSurveyConfirmModal' + quoteReference);
		},
		handleFileChange(e){
			var file = e.target.files[0]; 
			this.uploadData.quotePdf = file;
		},
		handleCopyStatus(){
			this.$toasted.success("Copied to clipboard", {
			    theme: 'bubble',
				position: 'bottom-center',
			    duration: 6000
			})
		},
		updateQuotation(){
			this.forceDisableSendQuoteBtn = true;
			this.$toasted.show("Please wait...", {
	            theme: 'bubble',
	            position: 'bottom-center',
	            duration: null
			})
			let data = Object.assign({}, this.uploadData);
			if(data.quotePdf === undefined){
				delete data.quotePdf
			}
			this.$store.dispatch('updateSurveyQuote', {quoteReference : this.surveyData.survey.quoteReference, data : data})
			.then((response) => {
				this.$toasted.clear()
				this.forceDisableSendQuoteBtn = false;
				if(response.confirmation === 'success'){
					this.$toasted.success("Survey updated!", {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
			        })
				} else {
					this.$toasted.error(response.message, {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
			        })
				}
			})
			.catch((err) => {
				this.$toasted.clear()
				this.forceDisableSendQuoteBtn = true;

				this.$toasted.error(err.message, {
			        theme: 'bubble',
			        position: 'bottom-center',
			        duration: 5000
			    })
			})
		}
	}
	
}
</script>


// WEBPACK FOOTER //
// src/components/common/Dashboard/CompletedSurvey.vue